<template>
  <div class="row">
    <div :class="waitingContractDischarge ? 'col-sm-12' : 'col-sm-9'">
      <alert-box ref="alertBox" class="spacer-bottom-s" />
    </div>

    <div class="col-sm-3" v-if="waitingReenrollmentPayment">
      <router-link
        tag="button"
        :to="{ name: 'reenrollment' }"
        class="z-button z-button--secondary z-button--block"
      >
        Fazer rematrícula
      </router-link>
    </div>
  </div>
</template>

<script>
import AlertBox from 'components/zilla/alert-box';

export default {
  props: {
    reenrollmentStatus: {
      type: String,
      required: true,
    },
  },
  components: {
    AlertBox,
  },
  mounted() {
    this.$refs.alertBox.show(
      this.alertMessage.type,
      this.alertMessage.text,
    );
  },
  computed: {
    alertMessage() {
      if (this.waitingContractDischarge) {
        return {
          type: 'warning',
          text: 'A rematrícula é liberada após pagamento de todas as mensalidades pendentes do semestre atual.',
        };
      }

      return {
        type: null,
        text: 'Rematrícula liberada! 🏃‍♂🏃‍♀',
      };
    },
    waitingContractDischarge() {
      return this.reenrollmentStatus === 'waiting_contract_discharge';
    },
    waitingReenrollmentPayment() {
      return this.reenrollmentStatus === 'waiting_reenrollment_payment';
    },
  },
};
</script>
